import { type ApiResponse } from '@/api/core/_models';
import { createMockChecklistRequests, DEFAULT_ACTOR } from './_mockRequests';
import {
  type ChecklistActivityRef,
  type ChecklistAnswerChange,
  type ChecklistCheckoutInput,
  type ChecklistRun,
  type ChecklistRunDetail,
} from './_models';

const checklistMockRequests = createMockChecklistRequests();

export function listRuns(): Promise<ApiResponse<ChecklistRun[]>> {
  return checklistMockRequests.listRuns();
}

export function getRun(id: string): Promise<ApiResponse<ChecklistRunDetail>> {
  return checklistMockRequests.getRun(id);
}

export function startRun(
  id: string,
  location?: string,
  actor = DEFAULT_ACTOR,
): Promise<ApiResponse<ChecklistRunDetail>> {
  return checklistMockRequests.startRun(id, location, actor);
}

export function saveAnswer(
  id: string,
  change: ChecklistAnswerChange,
  actor = DEFAULT_ACTOR,
): Promise<ApiResponse<ChecklistRunDetail>> {
  return checklistMockRequests.saveAnswer(id, change, actor);
}

export function sendRun(
  id: string,
  input: ChecklistCheckoutInput,
  actor = DEFAULT_ACTOR,
): Promise<ApiResponse<ChecklistRunDetail>> {
  return checklistMockRequests.sendRun(id, input, actor);
}

export function getActivityRuns(activity: ChecklistActivityRef): Promise<ApiResponse<ChecklistRun[]>> {
  return checklistMockRequests.getActivityRuns(activity);
}

export function skipOptionalRun(id: string): Promise<ApiResponse<ChecklistRun>> {
  return checklistMockRequests.skipOptionalRun(id);
}

export function cancelActivityRuns(taskId: string): Promise<ApiResponse<ChecklistRun[]>> {
  return checklistMockRequests.cancelActivityRuns(taskId);
}
